<marv-drawer #drawerMissionDetails size="big" (onDidDismiss)="this.onDidDismissDrawerMission($event)">
    @if(this.missionItemSelected){
        <app-mission-details 
            [operationId]="this.missionItemSelected.operation.id" 
            [missionId]="this.missionItemSelected.missionId" 
            [activityId]="this.missionItemSelected.activityId" 
            [source]="this.missionItemSelected.source" 
            [tabSelected]="this.missionDetailsTab"
            (onUpdateMission)="this.onUpdateMission($event)"
            (onDeleteMission)="this.onDeleteMission($event)"
            />
    }
</marv-drawer>

<ion-grid class="no_padding" >        
    <ion-row class="ion-align-items-center ion-justify-content-between"> 
        <ion-col size="12" size-md="6" class="title_card">
            {{'MISSONS_TO_EVALUATE' | translate}}
            <small>({{'LAST_10_DAYS' | translate}})</small>
            <marv-circle>{{this.missionsItemsToDisplay.length}}</marv-circle>            
        </ion-col>         
    </ion-row>     
</ion-grid>

<div id="missions_to_evaluate_list" class="ion-content-scroll-host">
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else {
        @if(this.missionsItemsDisplayed.length > 0){    
            @for(missionItem of this.missionsItemsDisplayed; track $index){
                <app-mission-item [mission]="missionItem" [displayProfil]="true" [displayEvaluation]="true" [displayBtnAddEvaluation]="true" [displayStatus]="false" (onSelectMission)="this.onSelectMission($event)" (onEvaluateMission)="this.onEvaluateMission($event)"/>
            }
            <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                <ion-infinite-scroll-content></ion-infinite-scroll-content>
            </ion-infinite-scroll>
        }
        @else{
            <marv-message type="info">{{'MSG_NO_MISSION_TO_EVALUATE' | translate}}</marv-message>
        }
    }
</div>
